import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { scrollbarTheming } from '@Styles/scrollbar'

const DEFAULT_MAX_HEIGHT = 600

export const autocomplete = (theme: Theme, maxHeight: number | undefined): SerializedStyles =>
  css(scrollbarTheming('transparent', theme.palette.primary.main), {
    borderBottom: `${rem(8)} solid transparent`,
    borderLeft: 0,
    borderRight: 0,
    borderTop: `${rem(8)} solid transparent`,
    outline: 'none',
    padding: theme.spacing(2, '0'),
    width: '100%',
    ...(maxHeight && {
      maxHeight: rem(maxHeight),
    }),
    [theme.breakpoints.up('md')]: {
      maxHeight: rem(maxHeight ?? DEFAULT_MAX_HEIGHT),
      overflow: 'auto',
      padding: theme.spacing(2, '0', 3),
    },
  })

export const sectionTitleFirstChild = css({
  marginTop: 0,
})

export const sectionTitle = (theme: Theme): SerializedStyles =>
  css({
    margin: theme.spacing(1, 2),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2),
    },
  })
